export default __webpack_public_path__ + "static/media/bolt.43de6a24.svg";